<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/wms/customer/page"
        getKey="rows" :columns="columns">

    </yi_curd_table>

  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_wms_delivery_issue_customer_information',
  components: {
  },
  data() {
    return {
      columns: [{
        label: 'kehubianma',
        prop: 'code',
      }, {
        label: 'kehumingcheng',
        prop: 'name',
      }, {
        label: 'kehudizhi',
        prop: 'address',
      },{
        label: 'lianxiren',
        prop: 'contacts',
      }, {
        label: 'lianxifangshi',
        prop: 'contactsInfo',
      },{
        label: 'chuangjianren',
        prop: 'createByObject.nickname',
      },{
        label: 'chuangjianshijian',
        prop: 'createTime',
        type: 'time',
        format: 'YYYY-MM-DD'
      }, {
        label: 'caozuo',
        type: 'slot',
        width: 150,
        fixed: 'right'
      }]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        // orderBy: 'createTime desc,triggerTime asc',
      }
      this.yt.SELECT_URL = "/web/wms/customer/listByIds"
      this.yt.SELECT_RESULT_KEY = "data"
      this.yt.SELECT_ID = "id"
      this.yt.SELECT_TITLE = "name"
      this.yt.get(1);
    }, 300)
  },

  methods: {

  }
};
</script>
